function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count-new]').forEach((el) => {
    el.textContent = count;
  });
}

function checkCartContents() {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      updateCartCount(cart.item_count);
    })
    .catch((e) => console.error('Cart fetch error:', e));
}

document.addEventListener('DOMContentLoaded', () => {
  const cartCountEl = document.querySelector('[data-cart-count-new]');
  if (!cartCountEl) return;

  checkCartContents(); // on page load

  // ✅ Listen for clicks on add-to-cart buttons
  document.body.addEventListener('click', function (e) {
    const isAddBtn = e.target.closest('form[action*="/cart/add"], [data-btn-addtocart], button[name="add"]');
    if (isAddBtn) {
      setTimeout(checkCartContents, 800);
    }
  });

    document.body.addEventListener('click', function (e) {
        if (e.target.id === 'opus-shadow-container') {
        setTimeout(checkCartContents, 800);
        }
    });
});
